import "./index.scss";

import {
  Box,
  CircularProgress,
  SelectChangeEvent,
  Table,
  TableBody,
  TableContainer,
} from "@mui/material";
import JournalAddEditComp from "components/JournalAddEdit";
import Pagination, { PAGE_OPTIONS } from "components/Pagination";
import { VIEW_INTERVAL_OPTIONS_JOURNAL } from "constants/index";
import dayjs from "dayjs";
import { useQueryParams } from "hooks/useQueryParams";
import { TPagination } from "modules/api/type";
import { getMemberJournals } from "modules/member/memberServices";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { Filter } from "./Filter";
import { TableHeader, TableItem } from "./TableComponents";

const Journal = () => {
  const { id } = useParams();
  let [isFetching, setIsFetching] = useState(false);
  let [data, setData] = useState([]);
  const [params, setParams, defaultParams, setObjParams] = useQueryParams({
    date_from: "",
    date_to: "",
    from: Date,
    limit: 10,
    member_id: id,
    page: 1,
    search: "",
    to: Date,
    view_interval_options: VIEW_INTERVAL_OPTIONS_JOURNAL[0].value,
  });
  const [pagination, setPagination] = useState<TPagination>({
    current_page: 0,
    data_from_offset: 0,
    data_to_offset: 0,
    per_page: PAGE_OPTIONS[0],
    total_pages: 0,
    total_records: 0,
  });
  const [selectedJournal, setSelectedJournal] = useState<any>(null);
  const [showJournalAddEditModal, setShowJournalAddEditModal] = useState<boolean>(false);

  useEffect(() => {
    fetchData(params);
  }, []);

  const fetchData = async (parameters) => {
    if (isFetching) return;
    setIsFetching(true);
    let result = await getMemberJournals(parameters);
    setIsFetching(false);
    if (result.success) {
      setData(result.data);
      setPagination(result.pagination);
    }
  };

  const onChangeFilterHandler = (obj) => {
    setObjParams(obj);
    let temp: any = {
      ...params,
      ...obj,
      page: 1,
    };
    //Validation filter
    if (temp.view_options === "CUSTOM" && (!temp.date_from || !temp.date_to)) {
      toast.error("Date Range is required for Custom option", {
        position: "top-center",
      });
      return;
    } else if (
      (temp.date_from?.length && !dayjs(temp.date_from).isValid()) ||
      (temp.date_to?.length && !dayjs(temp.date_to).isValid())
    ) {
      toast.error("Date is invalid", {
        position: "top-center",
      });
      return;
    }
    fetchData(temp);
  };

  const handlePaginationOptionChange = (event: SelectChangeEvent<any>) => {
    let temp = { ...params, limit: event.target.value, page: 1 };
    setParams("limit", event.target.value);
    fetchData(temp);
  };

  const handlePageChange = (page: number) => {
    let temp = { ...params, page };
    setParams("page", page);
    fetchData(temp);
  };

  return (
    <Box className="member-journal-container">
      <Filter
        params={params}
        defaultParams={defaultParams}
        onChange={onChangeFilterHandler}
        onClickAddRecord={() => {
          setSelectedJournal(null);
          setShowJournalAddEditModal(true);
        }}
      />
      <TableContainer className="member-workingout-table" sx={{ paddingBottom: "20px" }}>
        <Table aria-label="sticky table">
          <TableHeader />
          <TableBody>
            {!isFetching &&
              data.map((item, i) => (
                <TableItem
                  key={i}
                  data={item}
                  onClickEdit={(entry) => {
                    setSelectedJournal(entry);
                    setShowJournalAddEditModal(true);
                  }}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      {isFetching && (
        <Box display="flex" justifyContent="center">
          <CircularProgress style={{ alignSelf: "center" }} />
        </Box>
      )}
      <Pagination
        {...pagination}
        onPageChange={handlePageChange}
        pageDropdownProps={{
          defaultValue: pagination.per_page,
          onChange: handlePaginationOptionChange,
          value: pagination.per_page,
        }}
      />

      {showJournalAddEditModal && (
        <JournalAddEditComp
          open={showJournalAddEditModal}
          onClose={() => {
            setSelectedJournal(null);
            setShowJournalAddEditModal(false);
          }}
          selectedData={selectedJournal}
          memberId={id}
          callback={() => fetchData(params)}
        ></JournalAddEditComp>
      )}
    </Box>
  );
};

export default Journal;
